import {
    Alert,
    Box,
    CircularProgress,
    Stack,
} from '@mui/material';

import { Categories } from './Categories';

export const MainSection = ({ useFetchInit }) => {

    const { FetchData } = useFetchInit

    const { fetchAssignments } = FetchData
    const { dataAssignments, loadingFetchAssignments } = fetchAssignments

    return (
        <>
            {loadingFetchAssignments
                ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                        <CircularProgress />
                    </Box>
                )
                : dataAssignments.length === 0 
                    ? (
                        <Alert severity="info">
                            No hay categorías de cajas disponibles.
                        </Alert>
                    )
                    : (
                        <Stack spacing={4}>
                            <Categories
                                useFetchInit={useFetchInit}
                                dataAssignments={dataAssignments}
                            />
                        </Stack>
                    )
            }
        </>
    )
}
